import React from "react";
import moment from "moment";
import Chart from "react-apexcharts";

const DailyDepositsVSPayment = ({ depositVsPayment }) => (
    <Chart
        options={{
            chart: {
                id: "daily-range-depositVsPayment-bar",
                toolbar: {
                    show: true
                },
                zoom: {
                    enabled: true,
                    type: "x",
                    autoScaleYaxis: false,
                    zoomedArea: {
                        fill: {
                            color: "#90CAF9",
                            opacity: 0.4
                        },
                        stroke: {
                            color: "#0D47A1",
                            opacity: 0.4,
                            width: 1
                        }
                    }
                }
            },
            plotOptions: {
                bar: {
                    columnWidth: "50%",
                    endingShape: "arrow"
                }
            },
            stroke: {
                curve: "smooth"
            },
            xaxis: {
                categories: Object
                    .keys(depositVsPayment)
                    .map(timestamp => moment(parseInt(timestamp, 10))
                        .format("YYYY-MM-DD")),
                type: "datetime",
                labels: {
                    format: "dd MMM (ddd)"
                }
            },
            markers: {
                size: 6,
                strokeWidth: 3,
                fillOpacity: 0,
                strokeOpacity: 0,
                hover: {
                    size: 8
                }
            },
        }}
        series={[{
            name: "Deposits",
            data: Object.keys(depositVsPayment)
                .map(day => depositVsPayment[day].depositAmount)
        }, {
            name: "Payments",
            data: Object.keys(depositVsPayment)
                .map(day => depositVsPayment[day].paymentAmount)
        }]}
        type="line"
        width="100%"
        height={300}
    />
);

export default DailyDepositsVSPayment;



// WEBPACK FOOTER //
// ./src/views/pages/reports/daily-deposits-vs-payment.js